<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="onDatePicker"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="value"
        :label="label"
        prepend-icon="mdi-calendar"
        v-bind="attrs"
        v-on="on"
        @blur="updateFromTextfield"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      v-model="pickerValue"
      :type="dateType"
      min="1900-01-01"
      @change="updateField"
      :active-picker.sync="activePicker"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import * as dayjs from "dayjs";

import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      menu: false,
      pickerValue: null,
      activePicker: null,
      onDatePicker: false,
    };
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    dateType: {
      type: String,
      default: "date",
    },
  },
  methods: {
    updateField() {
      console.log(this.pickerValue);
      this.updateComponentValue();
    },
    updateComponentValue() {
      this.pickerValue = this.value
        ? dayjs(this.value).format("YYYY-MM-DD")
        : null;
    },
    updateFromTextfield() {
      const textfieldDate = dayjs(this.value, "M/D/YYYY");
      this.pickerValue = textfieldDate.isValid()
        ? textfieldDate.format("YYYY-MM-DD")
        : null;
      this.updateField();
    },
  },
  watch: {
    value: {
      immediate: true,
      handler: function () {
        this.updateComponentValue();
      },
    },
    activePicker() {
      /*
      we delay it because the content-click event will see "DATE" as the active
      picker when they've clicked on a month in the month picker (beacuse this takes
      them to the DATE screen). We want to make sure we only see "DATE" in the
      content-click event when clicking on a date
      */
      if (this.activePicker == this.dateType.toUpperCase())
        setTimeout(() => (this.onDatePicker = true), 100);
      else this.onDatePicker = false;
    },
  },
});
</script>
